/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/UrlCreator" />
import { getTFSPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

export function _getBuildUrl(buildId: number, pageContext: IVssPageContext) {
    const buildHubRoute = "ms.vss-build-web.ci-results-hub-route";

    const routeValues: { [key: string]: string } = {};
    routeValues["buildId"] = buildId.toString();

    return _fetchUrl(pageContext, routeValues, buildHubRoute);
}

export function _getcommitUrl(commitId: string, pageContext: IVssPageContext, repositoryName: string) {
    const commitHubRoute = "ms.vss-code-web.commit-route";

    const routeValues: { [key: string]: string } = {};
    routeValues["parameters"] = commitId;
    routeValues["vc.GitRepositoryName"] = repositoryName;

    return _fetchUrl(pageContext, routeValues, commitHubRoute);
}

export function _getRepositoryUrl(pageContext: IVssPageContext, repositoryName: string, refName: string) {
    if (!repositoryName) {
        return "";
    }
    const repoHubRoute = "ms.vss-code-web.files-route-git";

    const routeValues: { [key: string]: string } = {};
    routeValues["vc.GitRepositoryName"] = repositoryName;
    routeValues["version"] = "GB" + refToBranchName(refName);
    return _fetchUrl(pageContext, routeValues, repoHubRoute);
}

export function _getPullRequestUrl(pageContext: IVssPageContext, pullRequestId: string, repositoryName: string) {
    if (!pullRequestId) {
        return "";
    }
    const repoHubRoute = "ms.vss-code-web.pull-request-review-route";

    const routeValues: { [key: string]: string } = {};
    routeValues["vc.GitRepositoryName"] = repositoryName;
    routeValues["parameters"] = pullRequestId.toString();

    return _fetchUrl(pageContext, routeValues, repoHubRoute);
}

export function _fetchUrl(pageContext: IVssPageContext, routeValues: { [key: string]: string }, routeId: string) {
    const tfsProjectData = getTFSPageData(pageContext);

    routeValues["project"] = tfsProjectData && tfsProjectData.project ? tfsProjectData.project.name : "";

    return routeUrl(pageContext, routeId, routeValues);
}

export function refToBranchName(refName: string): string {
    return (refName || "").startsWith("refs/heads/") ? refName.substr("refs/heads/".length) : refName;
}
